module.exports = __webpack_public_path__ + "static/media/persimmon.7edfe49d.jpg";